var map = {
	"./blueCandle.png": "24cd",
	"./blueRing.png": "9836",
	"./blueRupee.png": "0fc5",
	"./bombHud.png": "4869",
	"./dungeonTriforce.png": "96cf",
	"./emptyHeart.png": "5cbd",
	"./fire0.png": "fa8d",
	"./fire1.png": "3bec",
	"./greenRaft-greenLink.png": "9dfc",
	"./greenRaft.png": "2545",
	"./greenSword.png": "c7b0",
	"./halfHeart.png": "6d5e",
	"./heart.png": "a8a6",
	"./hudLifeTitle.png": "ec63",
	"./keyHud.png": "4663",
	"./powerBracelet.png": "0239",
	"./primarySlot.png": "5ee1",
	"./redLetter.png": "d870",
	"./rupeeHud.png": "e51d",
	"./secondarySlot.png": "af70",
	"./sidebarTitle.png": "da78",
	"./virtualKeyboard/ctrl.png": "b4ae",
	"./virtualKeyboard/down.png": "f25b",
	"./virtualKeyboard/left.png": "a472",
	"./virtualKeyboard/right.png": "3c8f",
	"./virtualKeyboard/spacebar.png": "e5eb",
	"./virtualKeyboard/up.png": "95e0",
	"./whiteSword.png": "1be3",
	"./woodenSword.png": "5b62"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "12b8";